/* global axios */
import ApiClient from '../ApiClient';

class CopilotAccountConfig extends ApiClient {
  constructor() {
    super('copilot/config', { accountScoped: true });
  }

  update(data) {
    return axios.patch(this.url, data);
  }
}

export default new CopilotAccountConfig();
